import React from "react";
import teachingPng from "../../assets/数字化教研.png";
import rongkeTeachingPng from "../../assets/融课数字化教研.png";
import lessonPng from "../../assets/备课.png";
import educationPng from "../../assets/数字化教学.png";
import "./styles.css";

type IProps = { rongkeTag: boolean };

export const TrContent: React.FC<IProps> = (props) => {
  const { rongkeTag } = props;
  return (
    <>
      <div className="trcontent">
        <div className="content">
          <div className="trtitle">数字化教研</div>
          <div className="trnote">
            基于数字化教研系统的建设，通过一个软件即可随时开展多种形式的教研听评课活动，参与活动的评课、听课老师无需复杂操作，通过一个网页即可进行多视角实时解说式互动评课。教研会议结束后，录制教研评课过程，将会议录音转写为文本，自动生成会议纪要，留存点评记录，生成教研报告。
          </div>
          <div className="trpic">
            <img
              src={rongkeTag ? rongkeTeachingPng : teachingPng}
              width="1114"
              height="371"
            />
          </div>
        </div>
      </div>
      <div className="lessoncontent">
        <div className="content">
          <div className="lessontitle">数字化备课</div>
          <div className="lessonnote">
            数字化备课空间为教师提供一个协作性强、便捷高效的空间，以促进集体备课的开展和教学质量的提升。在嵌入人工智能生成式内容（AIGC）功能的同时，通过协作与共享、资源整合与组织、任务分配和进度管理、反馈与评估、数据分析等功能，帮助教师在备课过程中更好地合作、优化资源利用、提高备课效率和质量。
          </div>
          <div className="lessonpic">
            <img src={lessonPng} width="1200" height="538" />
          </div>
        </div>
      </div>
      {rongkeTag && (
        <div className="lessoncontent">
          <div className="content">
            <div className="lessontitle">数字化教学</div>
            <div className="lessonnote">
              数字化教学空间旨在将传统智慧教室与网络教学相融合，兼容学校已建设硬件设施，通过软件建设，推动传统智慧教室的线上线下融合、多校多课堂打通的空间融合、研备教学管串联的课前课后融合，为常态化教研教学提供软件基础。
            </div>
            <div className="lessonpic">
              <img src={educationPng} width="1200" height="523" />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
